'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Pagination = require('./Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'list';

function ListNoPagination(_ref) {
  var id = _ref.id,
      label = _ref.label,
      total = _ref.total,
      data = _ref.data,
      iteratorFn = _ref.iteratorFn,
      loadMore = _ref.loadMore;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement(
      'div',
      { className: 'list-container' },
      data.map(iteratorFn)
    ),
    total > data.length ? _react2.default.createElement(_Pagination2.default, {
      id: id,
      label: label,
      current: data.length,
      total: total,
      loadMore: loadMore
    }) : null
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(ListNoPagination);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ListNoPagination/ListNoPagination.jsx
// module id = 1085
// module chunks = 0